<template>
  <div>
    <el-card>
      <alter-form labelWidth="120px" :customeButton="true" :watchImageVisible="false" @handleChange="handleChange"
        ref="alterForm" @formSubmit="formSubmit" @handleAddFirstArray="handleAddFirstArray" :addFirstArray="false"
        :modifyData="modifyData" :formData="formData" :flex="'normal'" :collapseLength="collapseLength">
        <template v-slot:customeButton="data">
          <el-row>
            <el-collapse :value="[1]" style="border-top: 0;">
              <el-collapse-item :title="$t('form.purchase.itemList')" :name="1" :key="1" v-show="visible">
                <el-form ref="mainForm" :model="form" label-width="100px" :disabled="disabled">
                  <el-col :md="24" :lg="24">
                    <el-form-item :label="$t('form.purchase.itemList')"
                      :rules="[{ required: true, message: $t('text.require', { name: $t('form.purchase.itemList') }) }]"
                      prop="purchase_order_items_attributes">
                      <div v-for="(item, index) in form.purchase_order_items_attributes" :key="index">
                        <el-row v-if="!item._destroy"
                          style="border: 1px solid #EBEEF5; margin-bottom: 12px; padding: 12px;">
                          <el-col :md="24" :lg="8">
                            <el-form-item :label="$t('form.purchase.item')"
                              :rules="[{ required: true, message: $t('text.require', { name: $t('form.purchase.item') }) }]"
                              :prop="`purchase_order_items_attributes[${index}].shop_item_id`">
                              <el-select v-model="form.purchase_order_items_attributes[index].shop_item_id"
                                class="width-fill" :placeholder="$t('placeholder.defaultSelect')" clearable filterable
                                :loading="loading" @change="(e) => handleSelectChange(e, index)">
                                <el-option v-for="(item, index) in options[index].productList" :key="index"
                                  :label="item.name" :value="item.id"></el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                          <el-col :md="24" :lg="8">
                            <el-form-item
                              :rules="[{ required: true, message: $t('text.require', { name: $t('form.purchase.itemStock') }) }]"
                              :label="$t('form.purchase.itemStock')"
                              :prop="`purchase_order_items_attributes[${index}].shop_item_stock_id`">
                              <el-select v-model="form.purchase_order_items_attributes[index].shop_item_stock_id"
                                class="width-fill" :placeholder="$t('placeholder.defaultSelect')" clearable filterable
                                :loading="options[index].loading"
                                @change="(e) => handleSelectChange(e, index, 'shop_item_stock_id')">
                                <el-option v-for="(item, index) in options[index].item_stocks" :key="index"
                                  :label="item.name_text" :value="item.id"></el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                          <el-col :md="24" :lg="8">
                            <el-form-item
                              :rules="[{ required: true, message: $t('text.require', { name: $t('form.purchase.price') }) }]"
                              :label="$t('form.purchase.price')"
                              :prop="`purchase_order_items_attributes[${index}].item_price_f`">
                              <el-input type="number" @change="(data) => { return handleChange(data, 'item_price_f') }"
                                v-model="form.purchase_order_items_attributes[index].item_price_f"
                                :placeholder="$t('placeholder.defaultInput')"
                                :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :md="24" :lg="8">
                            <el-form-item
                              :rules="[{ required: true, message: $t('text.require', { name: $t('form.purchase.quantity') }) }]"
                              :label="$t('form.purchase.quantity')"
                              :prop="`purchase_order_items_attributes[${index}].quantity`">
                              <el-input @change="(data) => { return handleChange(data, 'quantity') }"
                                v-model="form.purchase_order_items_attributes[index].quantity"
                                :placeholder="$t('placeholder.defaultInput')"
                                :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :md="24" :lg="24" v-if="!disabled">
                            <el-button type="danger" @click="() => handleDelBtnClick(item, index)">{{ $t('button.delete')
                            }}</el-button>
                          </el-col>
                        </el-row>
                      </div>
                      <el-form-item v-if="!disabled">
                        <el-button icon="el-icon-plus" @click="handleAddBtnClick">{{ $t('button.add') }}</el-button>
                      </el-form-item>
                    </el-form-item>
                  </el-col>
                </el-form>
              </el-collapse-item>
            </el-collapse>
            <el-row type="flex" justify="center" v-if="!disabled" style="margin-top: 10px">
              <el-button @click="handleCancelClick">{{ $t('button.cancel') }}</el-button>
              <el-button type="primary" @click="formSubmit(data)">{{ $t('button.confirm') }}</el-button>
            </el-row>
          </el-row>
        </template>
      </alter-form>
    </el-card>
  </div>
</template>

<script>
import onlineCouponEdit from './index.js'
export default onlineCouponEdit
</script>

<style lang="scss" scope>
@import './index.scss';
</style>
